'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Page": "Polaris-Page",
  "fullWidth": "Polaris-Page--fullWidth",
  "narrowWidth": "Polaris-Page--narrowWidth",
  "Content": "Polaris-Page__Content"
};

exports.default = styles;
